import _extends from "@babel/runtime/helpers/extends";
import { useEffect } from 'react';
import { store } from "./store.js";
export function Corners(props) {
  useEffect(() => store.setDarkMode(_extends({}, props)), [props]);
  return null;
}